import React from 'react';

const PetaInteraktifGISDesa: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Setiap desa memiliki kekayaan bentang alam, batas wilayah adat, lahan pertanian subur, serta titik-titik fasilitas umum yang penting untuk dipetakan. Menampilkan informasi spasial tersebut dalam bentuk tabel teks panjang sering kali membosankan dan sulit dipahami oleh masyarakat maupun calon wisatawan.
      </p>

      <p className="mb-4">
        Penerapan <b>Web Geographic Information System (Web GIS)</b> interaktif pada website desa menjadi inovasi mutakhir yang mengubah data geografis yang kaku menjadi visualisasi peta interaktif yang hidup, informatif, dan mudah dieksplorasi dari perangkat seluler.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Fitur Unggulan Peta Digital Desa
      </h2>
      <ul className="list-disc pl-6 mb-6 space-y-3">
        <li>
          <strong>Layer Zonasi Hijau & Konservasi:</strong> Memetakan kawasan hutan lindung desa, area reboisasi, serta zonasi pertanian organik dengan kode warna poligon yang jelas.
        </li>
        <li>
          <strong>Penanda Lokasi Fasilitas Publik (Points of Interest):</strong> Menampilkan pin lokasi kantor balai desa, posyandu, puskesmas pembantu, bank sampah, dan sekolah yang dilengkapi jam operasional dan nomor kontak saat diklik.
        </li>
        <li>
          <strong>Rute Wisata dan Sentra UMKM:</strong> Memberikan panduan navigasi bagi wisatawan luar kota untuk menemukan lokasi pengrajin lokal, kebun petik buah, dan homestay warga.
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Integrasi Pustaka Pemetaan Ringan
      </h2>
      <p className="mb-4">
        Untuk memastikan peta dapat dimuat dengan cepat di jaringan internet pedesaan, pengembang memanfaatkan pustaka pemetaan open-source berukuran ringan seperti Leaflet.js atau OpenStreetMap yang diintegrasikan dengan data GeoJSON berukuran hemat memori.
      </p>

      <p className="mb-4">
        Visualisasi peta spasial interaktif ini tidak hanya meningkatkan transparansi tata kelola wilayah desa, tetapi juga menjadi etalase promosi pariwisata yang memikat bagi dunia luar.
      </p>
    </div>
  );
};

export default PetaInteraktifGISDesa;
